module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Music-note-82ab59014cf31a34e6ed28cc1eb559cb.svg";